<template>
  <div class="square-button" :class="{ selected: isSelected }" @click="handleClick()">
    <div class="square-button__content">
      <div class="square-button__title">{{ buttonText }}</div>
      <div class="square-button__description">{{ buttonDescription }}</div>
    </div>

    <!-- Phones: in a sheet, as a row's ⋯ (docs/page-layout.md). -->
    <BaseMoreActions v-if="isPhone && actionable" :title="buttonText" :actions="deleteActions" @select="handleDelete" />
    <v-menu v-else v-model="actionMenu" absolute>
      <template v-slot:activator="{ on, attrs }">
        <div v-if="actionable" class="document-tag__action" @click.stop v-on="on" v-bind="attrs">
          <BaseIcon class="document-tag__action-icon" name="more-horizontal" />
        </div>
      </template>
      <div class="base-actions-menu">
        <ul class="base-actions-menu__ul">
          <li class="base-actions-menu__li delete" @click="handleDelete">
            <BaseIcon :size="44" name="trash-2" />
            {{ $t('actions.delete') }}
          </li>
        </ul>
      </div>
    </v-menu>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseMoreActions from '@/components/base/BaseMoreActions.vue';
import { viewport } from '@/util/viewport';

export default {
  name: 'SquareButton',
  components: {
    BaseIcon,
    BaseMoreActions,
  },
  props: {
    buttonText: String,
    buttonDescription: String,
    buttonIcon: String,
    isSelected: Boolean,
    actionable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionMenu: false,
    };
  },
  computed: {
    isPhone() {
      return viewport.size === 'phone';
    },
    deleteActions() {
      return [{ key: 'delete', label: this.$t('actions.delete'), icon: 'trash-2', danger: true }];
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<style lang="scss">
.square-button {
  color: grey;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
  background-color: $color-slate-100;
  padding: 16px;
  border-radius: $border-radius-root;
  width: fit-content;
  max-width: 320px;
  cursor: pointer;
  transition: 200ms;
  border: 2px solid transparent;
  font-family: 'Lato' !important;

  &.selected {
    border: 2px solid $color-accent-500;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    color: $color-normal;
    font-weight: bold;
  }

  &__description {
    font-size: 12px;
    color: $color-normal-pale;
  }

  &__add-button {
    color: grey;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: $font-size-small;
    background-color: $color-slate-100;
    padding: 16px;
    border-radius: $border-radius-root;
    width: fit-content;
    max-width: 320px;
    cursor: pointer;
    transition: 200ms;
  }
}
</style>
